<template>
  <main>
    <v-container fluid>
      <v-slide-y-transition mode="out-in">
        <v-layout column align-center>
          <v-card :class="$style.loginForm" v-if="state === 'init'">
            <v-card-text>
              <v-flex xs12 class="text-sm-center">
                <v-progress-circular indeterminate class="amber--text"></v-progress-circular>
              </v-flex>
            </v-card-text>
          </v-card>

          <v-card :class="$style.loginForm" v-if="state === 'progress'">
            <v-card-text>
              <v-flex xs12>
                <v-progress-linear v-model="progress"></v-progress-linear>
              </v-flex>
            </v-card-text>
          </v-card>

          <v-form @keyup.native.enter="login">
            <v-card :class="$style.loginForm" v-if="state === 'login'">

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn x-large class="green--text" @click="login">Login</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-spacer></v-spacer>

            </v-card>
          </v-form>
        </v-layout>
      </v-slide-y-transition>
    </v-container>
  </main>
</template>

<style module>
.loginForm {
  width: 480px;
}
</style>

<script>
import AuthService from '../services/auth'


export default {
  data() {
    return {
      username: '',
      password: '',
      new_password: '',
      confirm_code: '',
      progress: 10,
      error: undefined,
      state: 'login',
      cognitoUser: undefined,
      extend_login_action: false,
      showPassword: false,
      currentUrl: ''
    }
  },

  mounted() {
    this.$store.commit('SET_TITLE', 'Login')

    AuthService.isValidSession()
      .then(() => {
        this.$router.push('/login')
      })
      .catch(err => {
        console.error('session invalid:', err)
        this.$store.commit('SHOW_MENU', false)
      })
  },

  methods: {
    login() {
      this.state = 'progress'
      AuthService.prepareAuth(this.$store.state.authConfig)
      AuthService.signIn()

    },

  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?425b7ea1